var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconTime = function SvgIconTime(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.159,
    height: 18.16,
    viewBox: "0 0 18.159 18.16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_916",
    "data-name": "Group 916",
    transform: "translate(-795.65 -275.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686",
    transform: "translate(-170.042 45.95)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 8.729,
    cy: 8.73,
    rx: 8.729,
    ry: 8.73,
    transform: "translate(966.042 230.05)",
    fill: "none",
    stroke: "#002063",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    transform: "translate(974.648 234.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M.037,5.6,0,0",
    fill: "#002063",
    stroke: "#002063",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_81",
    "data-name": "Line 81",
    x2: 6.048,
    transform: "translate(0 5.255)",
    fill: "none",
    stroke: "#002063",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    y2: 1.45,
    transform: "translate(974.772 230.05)",
    fill: "none",
    stroke: "#002063",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_83",
    "data-name": "Line 83",
    y2: 1.437,
    transform: "translate(974.772 246.01)",
    fill: "none",
    stroke: "#002063",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    x1: 1.458,
    transform: "translate(966.042 238.78)",
    fill: "none",
    stroke: "#002063",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    "data-name": "Line 85",
    x1: 1.54,
    transform: "translate(982.008 238.78)",
    fill: "none",
    stroke: "#002063",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTime, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_time.5a379a04.svg";
export { ForwardRef as ReactComponent };